require('intersection-observer');
import 'core-js';
import 'regenerator-runtime/runtime';

import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import store from './store'
import './registerServiceWorker'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
// Vuetify 2 defaults its internal component icons to the mdi set.
import '@mdi/font/css/materialdesignicons.css'
import './assets/css/roboto.scss'
import moment from 'moment-timezone';
import 'moment/locale/es';
import VueMoment from 'vue-moment';

import VueOnlinePlugin from 'vue-navigator-online'
import VueAnalytics from 'vue-analytics';
import { getConfig, assignAccess, add_gets,formalDateFormat,get_name_config_path } from './functions/general.js';
import modules from './modules.js';
import bs from './requests/bs.js';
const base = new bs(store);
const { get_export, put,put_no_id, patch, patch_m, gets, get, post, post_m, deleteRq, getsSimple,patch_restore  } = base;
import VueCryptojs from 'vue-cryptojs';
 
Vue.use(VueCryptojs)
Vue.use(VueOnlinePlugin)

// Configuración Moment
Vue.use(VueMoment, { moment });
Vue.filter('formatDateHour', value => (value
  ? moment(value, 'x').tz('America/Santiago').format('DD/MM/YYYY HH:mm')
  : 'No timestamp'));

Vue.config.productionTip = false
import Vuetify, { VCol,VFlex } from 'vuetify/lib'

const opts = {
  theme: {
    dark: false,
    light:true,
    themes: {
      light: {
        "primary": "#e9521d",
        "secondary": "#424242",
        "accent": "#82B1FF",
        "error": "#FF5252",
        "info": "#2196F3",
        "success": "#4CAF50",
        "warning": "#FB8C00",
        "background-color-1": "#FFFFFF",
        "background-color-2": "#E6E6E6",
      },
      dark: {
        "primary": "#e9521d",
        "secondary": "#FFFFFF",
        "accent": "#FFFFFF",
        "error": "#FF5252",
        "info": "#FFFFFF",
        "success": "#FFFFFF",
        "warning": "#FFFFFF",
        "background-color-1": "#292929",
        "card": "#424242",
        "background-color-2": "#151515",
      }
    } 
  }
};
/* theme--dark.v-card  */
Vue.use(Vuetify, {
  components: {
    'v-col':VCol, 
  }
})
// Layouts
Vue.component('v-flex', VFlex);
Vue.component('v-col', VCol);

import BlankLayout from './layouts/Blank.vue';
import DefaultLayout from './layouts/Default.vue';
import AdminLayout from './layouts/Admin.vue';

Vue.component('blank-layout', BlankLayout);
Vue.component('default-layout', DefaultLayout);
Vue.component('admin-layout', AdminLayout);

import V from '@/views/View.vue';
import SimpleForm from '@/components/crud/views/SimpleForm.vue';
import SimpleCrud from '@/components/crud/views/SimpleCrud.vue';
import SimpleCrud2 from '@/components/crud/views/SimpleCrudV2.vue';
import in_text from '@/components/inputs/in-text.vue';
import fs1 from './components/fs1.vue';
import fs1Dialog from './components/fs1-dialog.vue';
import fs1Span from './components/fs1-span.vue';
import fs1Div from './components/fs1-div.vue';
import fs1Expand from './components/fs1-expand.vue';
import fs1Tooltip from './components/fs1-tooltip.vue';
import fs1Tooltip2 from './components/fs1-tooltip2.vue';
import debounce_select from './components/debounce-select.vue';
import exp_panel from '@/components/outputs/fs1-expansion-panel.vue';
import value_container from '@/components/outputs/value_container.vue';
import in_num from '@/components/inputs/in-num.vue';
import in_text_area from '@/components/inputs/in-text-area.vue';
import in_calendar from '@/components/inputs/in-calendar.vue';
import in_range from '@/components/inputs/in-range.vue';
import in_select from '@/components/inputs/in-select.vue';
import in_switch from '@/components/inputs/in-switch.vue';
import in_combobox from '@/components/inputs/in-combobox.vue';
import in_user from '@/components/inputs/in-user.vue';
import in_table_user from '@/components/inputs/in-table-user.vue';
import imgs_container from '@/components/inputs/imgs_container.vue';
import export_ex from './components/inputs/export_ex.vue';
import debounceSelect from '@/components/filter_rq/debounce-select.vue';
import calendar_rq from '@/components/filter_rq/calendar-rq.vue';
import refresh_rq from '@/components/filter_rq/refresh-rq.vue';
import select_rq from '@/components/filter_rq/select-rq.vue';
import combobox_rq from '@/components/filter_rq/combobox-rq.vue';
import tgbtn_rq from '@/components/filter_rq/tgbtn-rq.vue';
import select_multiple_rq from '@/components/filter_rq/select-multiple-rq.vue';
import priority_rq from '@/components/filter_rq/priority-rq.vue';
import issues_status_rq from '@/components/filter_rq/issues-status-rq.vue';
import check_rq from '@/components/filter_rq/check-rq.vue';
import in_rq_ac from '@/components/inputs_rq/ac.vue';
import in_file from '@/components/inputs/in-file.vue';
import in_file_2 from '@/components/inputs/in-file-2.vue';
import template1 from '@/components/template-1.vue';
import in_select2 from '@/components/inputs/in-select2.vue';
import view_action from '@/components/actions/view.vue';
import TableFiles_d from '@/components/sparePart/files.vue';
import in_responsible_user from '@/components/inputs/in-responsible-user.vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import { isDev } from "./config";

Vue.component('V', V);
Vue.component('TableFiles_d', TableFiles_d);
Vue.component('SimpleForm', SimpleForm);
Vue.component('SimpleCrud', SimpleCrud);
Vue.component('SimpleCrud2', SimpleCrud2);
Vue.component('in-text', in_text);
Vue.component('fs1', fs1);
Vue.component('fs1-dialog', fs1Dialog);
Vue.component('fs1-span', fs1Span);
Vue.component('fs1-div', fs1Div);
Vue.component('fs1-expand', fs1Expand);
Vue.component('fs1-tooltip', fs1Tooltip);
Vue.component('fs1-tooltip2', fs1Tooltip2);
Vue.component('debounce-select-old', debounce_select);
Vue.component('debounce-select', debounceSelect);
Vue.component('exp-panel', exp_panel);
Vue.component('value-container', value_container);
Vue.component('in-num', in_num);
Vue.component('in-text-area', in_text_area);
Vue.component('in-calendar', in_calendar);
Vue.component('in-range', in_range);
Vue.component('in-select', in_select);
Vue.component('in-switch', in_switch);
Vue.component('in-combobox', in_combobox);
Vue.component('in-user', in_user);
Vue.component('in-table-user', in_table_user);
Vue.component('imgs-container', imgs_container);
Vue.component('export-ex', export_ex);
Vue.component('calendar-rq', calendar_rq);
Vue.component('refresh-rq', refresh_rq);
Vue.component('select-rq', select_rq);
Vue.component('combobox-rq', combobox_rq);
Vue.component('priority-rq', priority_rq);
Vue.component('issues-status-rq', issues_status_rq);
Vue.component('select-multiple-rq', select_multiple_rq);
Vue.component('check-rq', check_rq);
Vue.component('in-rq-ac', in_rq_ac);
Vue.component('in-file', in_file);
Vue.component('in-file-2', in_file_2);
Vue.component('template1', template1);
Vue.component('in-select2', in_select2);
Vue.component('view_action', view_action);
Vue.component('tgbtn-rq', tgbtn_rq);
Vue.component('in-responsible-user', in_responsible_user);

let endpoints = [];
let menuLateral = [];
const requests = { get_export:{}, put: {}, patch: {}, get: {}, post: {}, post_m: {}, gets: {}, delete: {}, getsSimple: {}, put_no_id:{},patch_restore:{} };
async function joinMenus()  {
  for (const m of modules) {
    const { default:r } = await import(`./modules/${m}/menu.js`);
    r.forEach(menu => menu.module = m);
    menuLateral = menuLateral.concat(r);
  }
  const menuLateralIndice = {};
  const asignarPadreEIndexar = (item) => {
    menuLateralIndice[item.id] = item;
    if (item.children) item.children.forEach(e => (e.parent = item) && asignarPadreEIndexar(e));
    if (item.tabs) item.tabs.forEach(e => (e.parent = item) && asignarPadreEIndexar(e));
  };
  menuLateral.forEach(item => asignarPadreEIndexar(item));
  store.dispatch('set', {key: 'menuLateral', val: menuLateral});
  store.dispatch('set', {key: 'menuLateralIndice', val: menuLateralIndice});
  return menuLateral;
}
import {v4 as uuid} from 'uuid';
const prs = [getConfig({modules,endpoints}), joinMenus()];

Promise.all(prs)
  .then(() => {
    store.dispatch('set', {key: 'endpoints', val: endpoints});
    store.dispatch('set', {key: 'requests', val: requests});
    endpoints.forEach(e => {
      const pkey = e.lpath || e.rp;
      
      if(e.m.includes('PUT_NO_ID')) requests.put_no_id[pkey] = put_no_id(get_name_config_path(e),e);
      if(e.m.includes('PUT')) requests.put[pkey] = put(get_name_config_path(e),e);
      if(e.m.includes('PATCH')) requests.patch[pkey] = patch(get_name_config_path(e),e);
      if(e.m.includes('PATCH_M')) requests.patch[pkey] = patch_m(get_name_config_path(e),e);
      if(e.m.includes('PATCH_RESTORE')) requests.patch_restore[pkey] = patch_restore(get_name_config_path(e),e);
      if(e.m.includes('GET_EXPORT')) requests.get_export[pkey] = get_export(get_name_config_path(e),e);
      
      
      
      if(e.m.includes('GETS')) {
        const names = e.name? e.name.map(n=>`${n}-${e.rp}`): [];
        add_gets(e.rp,e,store,e.name);
        names.forEach(name => add_gets(name,e,store));
      } // if
      if(e.m.includes('GETSS')) requests.getsSimple[pkey] = getsSimple(get_name_config_path(e),e);
      
      if(e.m.includes('GET')) requests.get[pkey] = get(get_name_config_path(e),e);
      if(e.m.includes('DELETE')) requests.delete[pkey] = deleteRq(get_name_config_path(e),e);
      if(e.m.includes('POST')) requests.post[pkey] = post(get_name_config_path(e),e);
      if(e.m.includes('POST_M')) requests.post[pkey] = post_m(get_name_config_path(e),e);
    });

    Vue.mixin({
      computed: {
        $socket() {return this.$store.getters.$socket},
        is_dev() { return isDev() },
        $user() {return this.session.user || {}},
        user_id(){ return this.$user.id },
        session() { return this.$store.getters.session || {} },
        requests(){ return this.$store.getters.requests },
        dark_t() { return this.$store.getters.dark},
        ie11(){ return !!window.MSInputMethodContext && !!document.documentMode },
        myPermissions() {
          /* debe ser asi, esto permite tambien tener actualizado los permisos del usuario */
          const profiles = this.$store.getters.profiles || [];
          if (!this.$user.profile) return [];
          if (!profiles.length) return [];
          return (profiles.find(f => f.id === this.$user.profile)||{}).permissions || []
        },
        myPermissionCodes() {
          const permissionIds = this.myPermissions;
          const allPermissions = this.$store.getters.permissions || [];
          return allPermissions
            .filter((permission) => permissionIds.includes(permission.id) && permission.code)
            .map((permission) => permission.code);
        },
        mobil(){ return ['xs','sm'].includes(this.$vuetify.breakpoint.name) },
      },
      methods: {
        datetimeConversor(stringDatetime) {
          if (stringDatetime === null) return 'No definida'
          const datetime = new Date(Date.parse(stringDatetime))
          return `${datetime.getUTCDate().toString().padStart(2, '0')}-${(datetime.getUTCMonth() + 1).toString().padStart(2, '0')}-${datetime.getUTCFullYear()}`
        },
        uuid,
        formalDateFormat(date){ return date ? formalDateFormat(new Date(date)): '' },
        fix(n){ return  typeof n === 'number' ? n.toFixed(2):'' },
        split_text(a) { return a ?  a.split('\n') : [] },
        dev_log() { if (this.is_dev) console.log.apply(null, arguments) },
        //get_filter(name){ return (this.$store.getters.requestStatus.find(f => f.name === name) || {}).filter },
        open_dialog(id){ this.$store.dispatch('open_dialog',id) },
        close_dialog(id){ this.$store.dispatch('close_dialog',id) },
        assignAccess,
        j(array,g){return Array.isArray(array) ? array.join(g): array},
        setSnackbar(snackbar) { this.$store.dispatch('setSnackbar',snackbar) },
        setProgress(progress) { this.$store.dispatch('setProgress',progress) },
        getError(e) {
          console.error(e);
          this.setProgress({show:false});
          this.setSnackbar({message:'Ocurrió un problema.',class:'error'});
        }
      },
    });

    const vueValues = async() => {
      const {default:router} =  await import ('./router');
      
      return {
        vuetify: new Vuetify(opts),
        //mixins: [mixin],
        router,
        store,
        render: h => h(App)
      }
    }
    vueValues()
      .then(values => {
        new Vue(values).$mount('#app');
        store.dispatch('set', {key: 'router', val: values.router});
        
        Vue.use(VueGoogleMaps, {
          load: {
            key: 'AIzaSyCIwnZ1213-EgU-tA4_9_eWPWErUhxeEys',
            //id:'3901562e286aae9f35e1081f',
            //libraries: 'places', // This is required if you use the Autocomplete plugin
          },
        });
        if (!isDev()) {
          Vue.use(VueAnalytics, {
            id: 'UA-100982558-5',
            router:values.router,
          })
        }
      });      
  })
